import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3729f58d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-whatsapp" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "whatsapp-link",
    href: _ctx.whatsappLink,
    target: "_blank"
  }, [
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_ctx.data.text ? _ctx.data.text : 'Message me'), 1)
  ], 8, _hoisted_1))
}